/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import Grid from "@mui/material/Grid";
import { useEffect, useMemo, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import MDBox from "components/MDBox";
import React from "react";
import { Box, IconButton, Menu, MenuItem, Select } from "@mui/material";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


import { DatePicker } from "antd";

import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";

import ComplexStatisticsCard1 from "examples/Cards/StatisticsCards/ComplexStatisticsCard1";
import LocationVisitsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard2";
import ChargerStatsCard from "examples/Cards/StatisticsCards/ChargerStatsCard";

import DashboardDrawer from "./DashboardDrawer";
import MapComponent from "../location_mgmt/components/MapComponent";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import ActivePieCard from "examples/Cards/InfoCards/ActivePieCard";
import EnergyConsumptionCard from "examples/Cards/InfoCards/EnergyConsumptionCard";
import CircularProgress from "@mui/material/CircularProgress";

import dashboard2 from "../../assets/cms-icons/session.png";
import dashboard3 from "../../assets/cms-icons/dashboard3.png";
import usersIcon from "../../assets/cms-icons/Revenue.png";
import DownloadsIcon from "../../assets/cms-icons/download.png";
import TotalCharger from "../../assets/cms-icons/Totalcharger.png";
import InactiveCharger from "../../assets/cms-icons/InactiveCharger.png";
import ActiveCharger from "../../assets/cms-icons/Activecharger.png";
import TotalDash from "../../assets/cms-icons/total_dash.png";
import DashboardCard from "examples/Cards/InfoCards/DashboardCard";
import DashboardTopCard from "examples/Cards/InfoCards/DashboardTopCard";
import leafIcon from "../../assets/images/icons/leafIcon.png"
import animationData from "../../assets/animations/animation1.json";
import { getCurrencySymbol } from "utils/Constant";
import GlobalHeatmap from "components/custom/GlobalHeatmap";
import { dashboardHeatmapData } from "components/custom/MockHeatmap";
import { Loader } from "@chatscope/chat-ui-kit-react";
import { formatCO2 } from "utils/format";
import dayjs from "dayjs";

import { handleSignout } from "utils/Logout";
import { getDecodedUserData } from "utils/Constant";
import { set } from "date-fns";
const { RangePicker } = DatePicker;


function Dashboard() {
  const [timeRange1, setTimeRange1] = useState("today");

  const handleDownload1 = () => {
    handleDownloadExcel();
  };
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [drawerRowData, setDrawerRowData] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [fromDate1, setFromDate1] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [toDate1, setToDate1] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(true);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [anchorEl, setAnchorEl] = useState(null);
  const [timeRange, setTimeRange] = useState("last30");
  const CO2_FACTOR = 0.58;

  const getCo2SeriesFromEnergy = (energyArray = []) =>
    energyArray.map((val) =>
      Number((parseFloat(val || 0) * CO2_FACTOR).toFixed(2))
    );

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    handleDownloadExcelSingle();
    handleMenuClose();
  };

  const [locations, setLocations] = useState([]);
  const [dashboardData, setDashboardData] = useState({});
  const [graphData, setGraphData] = useState({});
  const [mapLoaded, setMapLoaded] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedTitle, setSelectedTitle] = useState("Session");
  const [selectedLabels, setSelectedLabels] = useState(graphData?.labels || []);
  const [selectedData, setSelectedData] = useState(graphData?.revenue || []);
  const handleDownloadExcel = async () => {
    if (!graphData || !graphData.labels) {
      console.error("Graph data is missing!");
      return;
    }

    const workbook = new ExcelJS.Workbook();

    const createStyledSheet = (sheetName, labels = [], data = [], unit = "") => {
      const sheet = workbook.addWorksheet(sheetName);

      // Header
      const headerRow = sheet.addRow(["Date", sheetName + (unit ? ` (${unit})` : "")]);
      headerRow.font = { bold: true, size: 13 };
      headerRow.alignment = { horizontal: "center" };

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE082" },
        };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });

      //  DATA ROWS
      labels.forEach((label, index) => {
        const row = sheet.addRow([
          label,
          data[index] ?? 0,
        ]);

        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      sheet.columns.forEach((col) => {
        col.width = 20;
      });
    };



    //  Revenue (NEW sheet)
    createStyledSheet(
      "Revenue",
      graphData.labels,
      graphData.revenue,
      getCurrencySymbol(process.env.REACT_APP_CURRENCYCODE)
    );

    // Existing sheets
    createStyledSheet("Energy", graphData.labels, graphData.energy, "kWh");
    createStyledSheet("Sessions", graphData.labels, graphData.sessions);
    createStyledSheet(
      "CO2",
      graphData.labels,
      getCo2SeriesFromEnergy(graphData.energy),
      "kg"
    );


    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "cms_chrgup_data.xlsx");
  };

  const formatEnergy = (value) => {
    if (!value || isNaN(value)) return "0 kWh";

    const num = Number(value);

    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(2) + " TWh";
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2) + " GWh";
    } else {
      return (num / 1_000).toFixed(2) + " MWh";
    }
  };

  const handleDownloadExcelSingle = async () => {
    if (!selectedTitle || !selectedLabels?.length || !selectedData?.length) {
      console.error("Some data is missing!");
      return;
    }

    const workbook = new ExcelJS.Workbook();

    const sheet = workbook.addWorksheet(selectedTitle);

    // Header
    const headerRow = sheet.addRow([
      "Date",
      selectedTitle +
      (selectedTitle === "Energy"
        ? " (kWh)" : "")
    ]);


    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE082" },
      };
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });

    //  DATA ROWS
    selectedLabels.forEach((label, index) => {
      const row = sheet.addRow([
        label,
        selectedData[index] ?? 0,
      ]);

      row.eachCell((cell) => {
        cell.alignment = { horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    sheet.columns.forEach((col) => (col.width = 20));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${selectedTitle}_graph.xlsx`);
  };

  // const pieChartData = useMemo(() => ({
  //   charts: dashboardData?.chargerStates
  // }), [
  //   dashboardData?.chargerStates,
  // ]);




  const handleOpenDrawer = (title, apiEndpoint) => {
    axios({
      method: "get",
      url: process.env.REACT_APP_BASEURL + "charger-locations/" + apiEndpoint,
      withCredentials: true
    })
      .then((response) => {
        if (response.data.success === true) {
          const element = response.data.data;

          setDrawerRowData(element);
          setIsLoading(false);
          setDrawerTitle(title);
          setDrawerOpen(true);
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error" });
          const element = response.data.data;
          setDrawerRowData(element);
          setIsLoading(false);
          setDrawerTitle(title);
          setDrawerOpen(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setDrawerTitle(title);
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
  };


  const disabledDate = (current) => {
    if (!current) return false;

    // If no date selected yet → allow all
    if (!fromDate1) return false;

    const start = dayjs(fromDate1);

    // Disable dates more than 1 month after start
    return (
      current.isAfter(start.add(1, "month")) ||
      current.isBefore(start.subtract(1, "month"))
    );
  };

  const headers = [
    { label: "#", flex: 1, index: 0 },
    { label: "Location", flex: 4, index: 1 },
    { label: "Energy", flex: 2, index: 2 },
    { label: "Revenue", flex: 3, index: 3 },
    { label: "Sessions", flex: 1, index: 4 },
  ];

  const headers1 = [
    { label: "Type", flex: 1, index: 0 },
    { label: "Vehicle", flex: 4, index: 1 },
    { label: "Visits", flex: 1, index: 2 },
  ];

  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    axios({
      method: "get",
      url: process.env.REACT_APP_BASEURL + "charger-locations",
      withCredentials: true
    })
      .then((response) => {
        if (response.data.success === true) {
          const element = [];

          const dataWithChargerCount = response.data.data.map((location) => {
            const availCount = location.chargerInfo.filter(
              (charger) => charger.status === "Available"
            ).length;
            const inuseCount = location.chargerInfo.filter(
              (charger) => charger.status === "Inuse"
            ).length;
            const inactiveCount = location.chargerInfo.filter(
              (charger) => charger.status === "Inactive"
            ).length;
            const ele = {
              name: location.locationName,
              direction: location.direction,
              availCount: availCount,
              inuseCount: inuseCount,
              inactiveCount: inactiveCount,
              data: location,
            };
            element.push(ele);
            const acCount = location.chargerInfo.filter(
              (charger) => charger.type === "AC"
            ).length;
            const dcCount = location.chargerInfo.filter(
              (charger) => charger.type === "DC"
            ).length;
            const energyDisp =
              location.chargerInfo
                .reduce((total, charger) => {
                  const energyValue = parseFloat(
                    charger.energyConsumptions.replace(" kWh", "")
                  );
                  return total + energyValue;
                }, 0)
                .toFixed(2) + " kWh";
            const chargerInfoRep = location.chargerInfo.map((charger) => ({
              locationType: charger.powerOutput,
              chargers: charger.subtype,
              locationName: charger.name,
              energy_disp: charger.energyConsumptions,
              status:
                charger.status === "Available"
                  ? "Active"
                  : charger.status === "Inuse"
                    ? "Pending"
                    : "Inactive",
              c_type: charger.type,
            }));
            return {
              ...location,
              energy_disp: energyDisp,
              chargers: location.chargerInfo.length,
              c_type: `AC: ${acCount}, DC: ${dcCount}`,
              chargerInfoRep: chargerInfoRep,
            };
          });
          setLocations(element);
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          handleSignout();
        }
      });
    fetchAllChargers();
    fetchAllGraphData();
  }, []);

  useEffect(() => {
    fetchAllGraphData();
  }, [timeRange1, fromDate1, toDate1]);


  const fetchAllChargers = () => {
    setDashboardLoading(true);
    axios({
      method: "post",
      url:
        process.env.REACT_APP_BASEURL + "charger-locations/dashboard/get-data",
      withCredentials: true,
      data: {
        currency: process.env.REACT_APP_CURRENCYCODE,
      },
    })
      .then((response) => {
        if (response.data.success) {
          setDashboardData(response.data.data);
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        console.error(error);
        if (error?.response?.status === 401) {
          handleSignout();
        }
      })
      .finally(() => {
        setDashboardLoading(false);
      });
  };

  const fetchAllGraphData = () => {
    setIsLoading(true);
    axios({
      method: "get",
      url:
        process.env.REACT_APP_BASEURL +
        "graph/?filter=" +
        timeRange1 +
        "&start=" +
        fromDate1 +
        "&end=" +
        toDate1,
      withCredentials: true
    })
      .then((response) => {
        if (response.data.status) {
          setGraphData(response.data.data);
          setIsLoading(false);
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error" });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error?.response?.status === 401) {
          setIsLoading(false);
          handleSignout();
        }
      });
  };

  useEffect(() => {
    if (!graphData?.labels) return;

    setSelectedLabels(graphData.labels);

    if (selectedTitle === "Revenue") {
      setSelectedData(graphData.revenue || []);
    } else if (selectedTitle === "Session") {
      setSelectedData(graphData.sessions || []);
    } else if (selectedTitle === "Energy") {
      setSelectedData(graphData.energy || []);
    } else if (selectedTitle === "CO₂ Saved (kg)") {
      setSelectedData(getCo2SeriesFromEnergy(graphData.energy || []));
    }
  }, [graphData, selectedTitle]);



  useEffect(() => {
    if (localStorage.getItem("maploaded") === "true") {
      setMapLoaded(true);
    } else {
      setMapLoaded(false);
    }
  }, [localStorage.getItem("maploaded")]);

  const handleCardClick = (title, labels, data) => {
    setTimeRange(timeRange1);
    setSelectedTitle(title);
    setSelectedLabels(labels);
    setSelectedData(data);
    const element = document.getElementById("dash-graph");
    if (element) {
      const top = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };
  const memoLabels = useMemo(
    () => graphData?.labels ?? [],
    [graphData?.labels]
  );

  const memoUsers = useMemo(
    () => graphData?.users ?? [],
    [graphData?.users]
  );

  const memoSessions = useMemo(
    () => graphData?.sessions ?? [],
    [graphData?.sessions]
  );
  const memoRevenue = useMemo(
    () => graphData?.revenue ?? [],
    [graphData?.revenue]
  );

  const memoEnergy = useMemo(
    () => graphData?.energy ?? [],
    [graphData?.energy]
  );

  const EMISSION_FACTOR = 0.85;

  const memoCo2 = useMemo(() => {
    // If energy data not ready yet, return zero-filled array
    if (!Array.isArray(graphData?.energy)) {
      return new Array(memoLabels?.length || 0).fill(0);
    }

    return graphData.energy.map((item) => {
      // support both number[] and object[]
      const value =
        typeof item === "number"
          ? item
          : Number(item?.value ?? item?.y ?? 0);

      return Number.isFinite(value) ? value * EMISSION_FACTOR : 0;
    });
  }, [graphData?.energy, memoLabels]);


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <DashboardDrawer
        title={drawerTitle}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        rowData={drawerRowData}
        isLoading={isLoading}
      />
      <MDBox>
        <Grid
          container
          spacing={2}
          mt={0.5}
          sx={{
            display: {
              xs: "flex",
              lg: "none",
            },
          }}
        >
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ChargerStatsCard
                icon={TotalCharger}
                color="dark"
                title="Total Charge points"
                count={
                  isLoading ? (
                    <CircularProgress
                      sx={{
                        color: "#1976d2",
                        animationDuration: "700ms",
                      }}
                    />
                  ) : (
                    dashboardData?.totalChargers || 0
                  )
                }
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1}>
              <ChargerStatsCard
                icon={InactiveCharger}
                title="Active Charge Points"
                color="success"
                count={
                  isLoading ? (
                    <CircularProgress
                      sx={{ color: "#1976d2", animationDuration: "700ms" }}
                    />
                  ) : (
                    dashboardData?.chargerStates?.Available +
                    dashboardData?.chargerStates?.Charging || 0
                  )
                }
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1}>
              <ChargerStatsCard
                color="error"
                icon={ActiveCharger}
                title="Inactive Charge Points"
                count={
                  isLoading ? (
                    <CircularProgress
                      sx={{ color: "#1976d2", animationDuration: "700ms" }}
                    />
                  ) : (
                    dashboardData?.chargerStates?.Inactive || 0
                  )
                }
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1}>
              <ComplexStatisticsCard1
                color="dark"
                title="Active Charge Points"
                title1="Inuse"
                title2="Available"
                count1={dashboardData?.chargerStates?.Charging || 0}
                count2={dashboardData?.chargerStates?.Available || 0}
                colorcount1="#95C1DF"
                colorcount2="#198038"
              />
            </MDBox>
          </Grid>
        </Grid>
        <Grid container spacing={3} mt={2}>
          <Grid item xs={12} md={12} mb={3}>
            <div
              style={{
                height: mapLoaded && "80vh",
                marginBottom: "34px",
                position: "relative", //  main positioning context
              }}
            >
              {/*  MAP — stays in background */}
              <MapComponent
                locations={locations}
                givenHeight="80vh"
                zoomLevel={9}
              />

              {mapLoaded && (
                <>
                  {/*  CARDS + SELECTOR WRAPPER */}
                  <MDBox
                    sx={{
                      position: "absolute",
                      inset: 0, // fill map area
                      pointerEvents: "none", // map still scrollable
                    }}
                  >
                    {/*  TODAY SELECTOR (anchored to cards) */}
                    <MDBox
                      sx={{
                        position: "absolute",
                        right: { xs: 8, sm: 12, md: 16 },
                        bottom: {
                          xs: "calc(25% + 12px)",
                          md: "calc(28% + 12px)",
                        },
                        zIndex: 200,
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        pointerEvents: "auto",
                      }}
                    >
                      {timeRange1 === "custom" && (
                        <RangePicker
                          size="small"
                          format="YYYY-MM-DD"
                          style={{ height: 28 }}
                          disabledDate={disabledDate}
                          onCalendarChange={(dates) => {
                            if (dates?.[0]) {
                              setFromDate1(dates[0]);
                            }
                          }}
                          onChange={(value, dateString) => {
                            setFromDate1(dateString[0]);
                            setToDate1(dateString[1]);
                          }}
                        />

                      )}

                      {/*  COMPACT SELECT */}
                      <Select
                        value={timeRange1}
                        onChange={(e) => setTimeRange1(e.target.value)}
                        size="small"
                        sx={{
                          height: 30,
                          minWidth: 72,
                          fontSize: "0.75rem",
                          textAlign: "center",
                          backgroundColor: darkMode ? "#202940" : "#FFFFFF",
                          borderRadius: "8px",
                          "& .MuiSelect-select": {
                            padding: "4px 8px",
                            display: "flex",
                            alignItems: "center",
                          },
                        }}
                      >
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="yesterday">Yesterday</MenuItem>
                        <MenuItem value="weekly">Last Week</MenuItem>
                        <MenuItem value="last30">Last Month</MenuItem>
                        <MenuItem value="custom">Custom</MenuItem>
                      </Select>

                      {/*  DOWNLOAD BUTTON WITH BACKGROUND */}
                      <IconButton
                        onClick={handleDownload1}
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "8px",
                          backgroundColor: darkMode ? "#202940" : "#FFFFFF",
                          border: darkMode
                            ? "1px solid rgba(255,255,255,0.15)"
                            : "1px solid #E0E0E0",
                          "&:hover": {
                            backgroundColor: darkMode ? "#2A3558" : "#F4F6FA",
                          },
                        }}
                      >
                        <img
                          src={DownloadsIcon}
                          alt="Download"
                          style={{
                            width: 14,
                            height: 14,
                            filter: darkMode ? "invert(1)" : "none",
                          }}
                        />
                      </IconButton>
                    </MDBox>

                    {/* CARDS */}
                    <Grid
                      container
                      spacing={2}
                      px={2}
                      sx={{
                        position: "absolute",
                        bottom: "0",
                        width: "100%",
                        pointerEvents: "auto",
                      }}
                    >
                      {/* your CO₂ + other cards */}
                    </Grid>
                  </MDBox>
                </>
              )}
              {/*  CARDS */}
              <Grid
                container
                px={3}
                spacing={2}
                sx={{
                  position: "absolute",
                  top: 16,
                  left: 0,
                  width: "100%",
                  pointerEvents: "auto",
                }}
              >
                <div style={{ display: "flex", gap: "16px", marginTop: 10 }}>

                  <DashboardTopCard
                    imgicon={TotalDash}
                    label="Total Charge Points"
                    disabled={dashboardLoading}
                    bgcolor="#8b83cc"
                    count={
                      dashboardLoading ? (
                        <CircularProgress
                          size={14}
                          sx={{
                            color: "#1976d2",
                            animationDuration: "700ms",
                          }}
                        />
                      ) : (
                        dashboardData?.totalChargers || 0
                      )
                    }
                    onClick={() =>
                      handleOpenDrawer(
                        "Total Chargers",
                        "dashboard/charger?status=all"
                      )
                    }
                  />
                  <DashboardTopCard
                    imgicon={ActiveCharger}
                    label="Active Charge Points"
                    bgcolor="#C4EA65"
                    disabled={dashboardLoading}
                    count={
                      dashboardLoading ? (
                        <CircularProgress
                          size={14}
                          sx={{
                            color: "#1976d2",
                            animationDuration: "700ms",
                          }}
                        />
                      ) : (
                        dashboardData?.chargerStates?.Available +
                        dashboardData?.chargerStates?.Charging + dashboardData?.chargerStates?.Preparing || 0
                      )
                    }
                    onClick={() =>
                      handleOpenDrawer(
                        "Active Chargers",
                        "dashboard/charger?status=active"
                      )
                    }
                  />
                  <DashboardTopCard
                    imgicon={InactiveCharger}
                    label="Inactive Charge Points"
                    bgcolor="#FF7878"
                    disabled={dashboardLoading}
                    count={
                      dashboardLoading ? (
                        <CircularProgress
                          size={14}
                          sx={{
                            color: "#1976d2",
                            animationDuration: "700ms",
                          }}
                        />
                      ) : (
                        dashboardData?.chargerStates?.Inactive + dashboardData?.chargerStates?.Faulted + dashboardData?.chargerStates?.SuspendedEVSE || 0
                      )
                    }
                    onClick={() =>
                      handleOpenDrawer(
                        "Inactive Charge Points",
                        "dashboard/charger?status=inactive"
                      )
                    }
                  />
                </div>

                {/* </div> */}
              </Grid>



              {mapLoaded && (
                <>


                  <Grid
                    container
                    spacing={2}
                    px={2}
                    sx={{
                      position: {
                        md: "static",

                        lg: "relative",
                      },
                      display: {
                        xs: "none",
                        lg: "flex",
                      },

                      bottom: "38%",
                    }}
                  >
                    <Grid item xs={12}>
                      <MDBox
                        sx={{
                          width: "18%",

                          position: {
                            md: "static",

                            lg: "relative",
                          },
                          display: {
                            xs: "none",
                            lg: "block",
                          },
                          top: "0%",
                          zIndex: "14",
                          marginBottom: "1rem",
                        }}
                      >
                        <DashboardTopCard
                          lottieicon={animationData}
                          label="Live session"
                          bgcolor="#F6F6F6"
                          disabled={dashboardLoading}
                          count={dashboardLoading ? (
                            <CircularProgress
                              size={14}
                              sx={{
                                color: "#1976d2",
                                animationDuration: "700ms",
                              }}
                            />
                          ) : (
                            dashboardData?.activeSessions || 0
                          )}

                          onClick={() =>
                            handleOpenDrawer(
                              "Live Session",
                              "dashboard/charger?status=live"
                            )
                          }
                        />
                      </MDBox>
                    </Grid>



                    <Grid
                      item
                      xs={12}
                      md={6}
                      lg={3}
                      onClick={() =>
                        handleCardClick(
                          "Session",
                          graphData?.labels || [],
                          graphData?.sessions || []
                        )
                      }
                    >
                      <MDBox mb={1}>
                        <DashboardCard
                          color="purple"
                          colorcode="#C5C0FF"
                          selectedCardCode="#F1F0FF"
                          imgicon={dashboard2}
                          title="Session"
                          isSelected={selectedTitle === "Session"}
                          count={graphData?.total?.sessions || 0}
                          labels={memoLabels}
                          data1={memoSessions}
                          darkMode={darkMode}
                          loading={isLoading}
                          percentage={{
                            color: "success",
                            amount: "+1%",
                            label: "than yesterday",
                          }}
                        />
                      </MDBox>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={6}
                      lg={3}
                      onClick={() =>
                        handleCardClick(
                          "Energy",
                          graphData?.labels || [],
                          graphData?.energy || []
                        )
                      }
                    >
                      <MDBox mb={1}>
                        <DashboardCard
                          color="success"
                          colorcode="#F0491E"
                          selectedCardCode="#ffe3e3ff"
                          imgicon={dashboard3}
                          title="Energy"
                          isSelected={selectedTitle === "Energy"}
                          count={formatEnergy(graphData?.total?.energy)}
                          labels={memoLabels}
                          data1={memoEnergy}
                          loading={isLoading}
                          darkMode={darkMode}
                          percentage={{
                            color: "success",
                            amount: "+1%",
                            label: "than yesterday",
                          }}
                        />
                      </MDBox>
                    </Grid>

                    <Grid
                      id="dash-graph"
                      item
                      xs={12}
                      md={6}
                      lg={3}
                      onClick={() =>
                        handleCardClick(
                          "Revenue",
                          graphData?.labels || [],
                          graphData?.revenue || []
                        )
                      }
                    >
                      <MDBox mb={1}>
                        <DashboardCard
                          color="warning"
                          colorcode="#FFA726"
                          selectedCardCode="#FFF0DA"
                          imgicon={usersIcon}
                          title="Total Cost"
                          isSelected={selectedTitle === "Revenue"}

                          count={
                            getCurrencySymbol(process.env.REACT_APP_CURRENCYCODE) + " " +
                            graphData?.total?.revenue || 0
                          }
                          loading={isLoading}
                          labels={memoLabels}
                          data1={memoRevenue}
                          percentage={{
                            color: "success",
                            amount: "+1%",
                            label: "than yesterday",
                          }}
                        />
                      </MDBox>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={6}
                      lg={3}
                      onClick={() =>
                        handleCardClick(
                          "CO₂ Saved (kg)",
                          graphData?.labels || [],
                          graphData?.energy || []
                        )
                      }
                    >
                      <MDBox mb={1}>
                        <DashboardCard
                          color="success"
                          colorcode="#4CAF50"
                          selectedCardCode="#c6f0c8ff"
                          imgicon={leafIcon}
                          iconBg="#7CD541"
                          title="CO₂ Saved"
                          isSelected={selectedTitle === "CO₂ Saved (kg)"}
                          count={formatCO2(
                            (parseFloat(graphData?.total?.energy) || 0) * 0.58
                          )}
                          labels={memoLabels}
                          data1={memoCo2}
                          loading={isLoading}
                          darkMode={darkMode}
                          percentage={{
                            color: "success",
                            amount: "+1%",
                            label: "than yesterday",
                          }}
                        />

                      </MDBox>
                    </Grid>
                  </Grid>
                </>
              )}
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3} mt={5} alignItems="stretch">
          <Grid item xs={12} lg={8} sx={{ display: "flex" }}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                borderRadius: "12px",
              }}
            >
              <MDBox padding="1.5rem"
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "1.5rem",
                    paddingBottom: "1rem",
                    borderBottom: darkMode
                      ? "1px solid rgba(255,255,255,0.1)"
                      : "1px solid rgba(0,0,0,0.08)",
                    flexDirection: window.innerWidth < 600 ? "column" : "row",
                    gap: "0.5rem",
                  }}
                >
                  <MDTypography
                    variant="h5"
                    fontWeight="bold"
                    sx={{
                      fontSize: { xs: "1.05rem", sm: "1.15rem", md: "1.2rem" },
                      textAlign: { xs: "left", sm: "left" },
                    }}
                  >
                    {selectedTitle === "Energy"
                      ? "Energy (kWh)"
                      : selectedTitle === "Revenue"
                        ? `Revenue (${getCurrencySymbol(process.env.REACT_APP_CURRENCYCODE)})`
                        : selectedTitle === "CO₂ Saved (kg)"
                          ? "CO₂ Saved (kg)"
                          : selectedTitle}
                  </MDTypography>
                  <div style={{ display: "flex", alignItems: "center" }}>



                    <IconButton
                      onClick={handleDownload}
                      sx={{
                        width: "2rem",
                        height: "2rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: darkMode ? "#202940" : "#F6F6F6",
                        border: darkMode
                          ? "1px solid rgba(255,255,255,0.1)"
                          : "1px solid #E3E3E3",
                        padding: "5px",
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: "#A6DBFF",
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      <img
                        src={DownloadsIcon}
                        alt="Download"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          objectFit: "contain",
                          filter: darkMode ? "invert(1) brightness(2)" : "none",
                        }}
                      />
                    </IconButton>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={handleDownload}>Download</MenuItem>
                    </Menu>
                  </div>
                </div>

                <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                  <EnergyConsumptionCard
                    title={selectedTitle}
                    labels={selectedLabels}
                    data1={selectedData}
                    yAxisLabel={
                      selectedTitle === "Energy" ? "Energy (kWh)" :
                        selectedTitle === "Revenue" ? `Revenue (${getCurrencySymbol(process.env.REACT_APP_CURRENCYCODE)})` :
                          selectedTitle === "CO₂ Saved (kg)" ? "CO₂ (kg)" :
                            "Count"
                    }
                    colorcode={
                      selectedTitle === "Energy"
                        ? "#EA471D"
                        : selectedTitle === "CO₂ Saved (kg)"
                          ? "#4CAF50"
                          : selectedTitle === "Revenue"
                            ? "#FFA726"
                            : selectedTitle === "Session"
                              ? "#C5C0FF"
                              : "#FFF"
                    }
                  />

                </Box>

              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ display: "flex" }}>
            <Card
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                borderRadius: "12px",
              }}
            >

                <ActivePieCard
                  chart={dashboardData?.chargerStates}
                  darkMode={darkMode}
                />
            </Card>
          </Grid>

        </Grid>


      </MDBox >
    </DashboardLayout >
  );
}

export default Dashboard;
